'use strict';

import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { Prompt } from 'react-router'

import ControlEtiqueta from "./Controles/ControlEtiqueta";
import BotonGuardarCancelar from "./Controles/BotonGuardarCancelar";
import Modal from './Modal';
import Titulo from "./Controles/Titulo";
import Equivalencias from './Controles/Equivalencias';
import MensajeError from './Controles/MensajeError';

/*Variable usada para determinar si se modifico algun campo en la pantalla*/
let seModifico = false;
/**
 * 
 */
class NuevaInstanciaParametro extends Component {
    constructor(props) {
        super(props);

        /*Bindings*/
        this.generarControles = this.generarControles.bind(this);
    }
    /**
    * 
    */
    generarControles() {
        const { actualizarParametro, data } = this.props;
        const { instancias } = data;
        /*Filtro los visibles y los recorro*/
        return instancias.filter((con1) => con1.EstaVisible).map((con2, index) => {
            return <ControlEtiqueta control={con2} key={"controlItem_" + index}
                actualizarParametro={actualizarParametro} esAltaInstancia={data.esAltaInstancia}/>
        });
    }
    /**
     * 
     */
    componentDidMount() {
        const { props } = this;

        window.onbeforeunload = function (event) {
            if (seModifico) {
                return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
            }
        }

        this.props.obtenerInformacionPantalla(this.props.currentScope);
    }
    /**
     * 
     */
    componentWillUnmount() {
        window.onbeforeunload = null;
        this.props.reiniciarEstado();
    }
    /**
     * 
     */
    render() {
        /*Si no cargó los datos de la pantalla no renderizo los componentes*/
        if (this.props.data.dataRecuperada == false) {
            return <div className="loading"> Loading &#8230;</div>;
        }
        /*Ruteo a vista instancia parametro*/
        if (this.props.data.rutearVistaInstancia) {
            return <Redirect push to={this.props.data.rutaVistaInstancia + "/" + this.props.atlas.entidadId} />;
        }

        seModifico = this.props.data.seModifico;
        let entidadInstanciaActiva = this.props.data.instancias[0] && this.props.data.instancias[0].Activo;

        return (
            <div>
                {this.props.data.seEstaGuardando &&
                    <div className="loading"> Loading &#8230;</div>}


                <Titulo atlas={this.props.atlas} data={this.props.data} />
                <MensajeError huboError={this.props.data.huboError} />

                <div onClick={() => this.props.cambiarActivoInstanciaParametro()} className="contenedorNuevaInstanciaActivo">
                    <div className="contenedorCheckboxActivo default-checkbox">
                        <input disabled={false} id={"check-activo-parametro-"} type="checkbox" checked={entidadInstanciaActiva} />
                        <label className={"label-primary " + (true ? "" : "disabledGrey")} htmlFor={"check-visualizar-viajes-vigentes"}></label>
                    </div>
                    <label className="label-primary labelCheckAvisoViaje" htmlFor={"check-visualizar-viajes-vigentes"}>Activo</label>
                </div>
                {this.generarControles()}
                <Equivalencias data={this.props.data}
                    agregarEquivalencia={this.props.agregarEquivalencia}
                    eliminarEquivalencia={this.props.eliminarEquivalencia}
                    actualizarEquivalencia={this.props.actualizarEquivalencia}
                    actualizarSubEquivalencia={this.props.actualizarSubEquivalencia}
                    setValorDefault={this.props.setValorDefault} />
                <MensajeError huboError={this.props.data.huboError} />

                <div className="Personeria bottom-separator-xs" style={{ color: 'gray' }}>Los campos con * son obligatorios.</div>

                <div className="contenedorSeparadorNuevaInstanciaParametro"></div>

                <BotonGuardarCancelar
                    atlas={this.props.atlas}
                    mostrarSpinner={this.props.mostrarSpinner}
                    guardarNuevaInstanciaParametro={this.props.guardarNuevaInstanciaParametro}
                    huboError={this.props.data.huboError}/>

                <Modal atlas={this.props.atlas}
                    mostrarModal={this.props.data.mostrarModal}
                    mensaje={this.props.saga.mensaje}
                    finalizarSaga={this.props.finalizarSaga} />
                
                {/* Modal de Error Validacion Post-Validador */}
                <Modal atlas={this.props.atlas}
                    mostrarModal={this.props.data.mostrarModalPostValidador}
                    mensaje={this.props.data.mensajePostValidador}
                    finalizarSaga={this.props.ocultarMostrarModalPostValidador} />
            </div >
        );
    }
}

export default NuevaInstanciaParametro;